import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0f9ca10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-page" }

import loadingPng from '@/assets/images/empty/empty-loading.png'

export default /*#__PURE__*/_defineComponent({
  __name: 'loadingPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_empty, {
      image: _unref(loadingPng),
      description: "页面加载中，请稍候。。。"
    }, null, 8, ["image"])
  ]))
}
}

})